import React from "react";
import ProductCard from "./ProductCard/ProductCard";

export default function ProductsList({ data, toggle, toggleTempUnavailable, toggleSale }) {
  return (
    <div className="row">
      {data.length > 0
        ? data.map((item, index) => (
            <ProductCard
              key={item.id}
              item={item}
              index={index}
              toggle={toggle}
              toggleSale={toggleSale}
              toggleTempUnavailable={toggleTempUnavailable}
            />
          ))
        : "No Items Available"}
    </div>
  );
}
